import { state, style, trigger } from '@angular/animations';
import { AfterContentInit, Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { BooleanStateService } from '../../services/boolean-state.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  animations: [
    trigger('showHide', [
      state(
        'true',
        style({
          visibility: 'visible',
        }),
      ),
      state(
        'false',
        style({
          visibility: 'hidden',
        }),
      ),
    ]),
  ],
})
export class ProgressBarComponent implements AfterContentInit, OnDestroy {
  @Input()
  public visibility: boolean;

  private stateSubscription: Subscription;

  constructor(public progressBarService: BooleanStateService) {}

  public ngAfterContentInit(): void {
    this.visibility = !!this.visibility;
    this.stateSubscription = this.progressBarService.stateSource
      .pipe(
        distinctUntilChanged(),
        tap((state: boolean) => {
          setTimeout(() => {
            this.visibility = state;
          });
        }),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.stateSubscription.unsubscribe();
  }
}
